/*
<template>
    <div id="insighs-audio-player-container">
        <insighs-player
            v-if="audioSources.length"
            :sources="selectedAudio"
            :rates="rates"
            @play="onPlay"
            @end="onPlaybackEnd"
            @load="onLoad"
        />
    </div>
</template>
*/
import _cloneDeep from "lodash/cloneDeep";
import _isEmpty from "lodash/isEmpty";
import { replaceUrlProtocol } from "@/utils/filters";

export default {
    data() {
        return {
            isPlaying: false,
            rate: "1.0",
            selectedAudioSource: 0,
            currentAudioState: {},
            rates: ["1.0", "1.5", "1.75", "2.0", "2.5", "3.0"],
            audioSources: []
        }
    },
    props: {
        autoplay: {
            type: [Boolean, String],
            default: false
        }
    },
    computed:{
        selectedAudio() {
            if (this.audioSources.length) {
                return this.audioSources[this.selectedAudioSource].audioSrc;
            }
            return [];
        }
    },
    methods: {
        onLoad() {
            if (!_isEmpty(this.currentAudioState)) {
                this.restoreCurrentAudioState(this.currentAudioState);
            }
        },
        onPlaybackEnd() {
            this.isPlaying = false;
            if (this.autoplay && this.audioSources.length > 1) {
                if (this.audioSources.length > (this.selectedAudioSource + 1)) {
                    this.nextTrack();
                } else {
                    this.previoustrack();
                }
            }

        },
        onPlay() {
            // audio controls
            // const album = this.bookInsight.external_book.title;
            // const title = this.bookInsight.title;
            // const artist = this.bookInsight.authors.map((author) => author.name).join(", ");
            //   const artworkSrc = _get(this.bookInsight, "external_book.url", "");
            // let artwork = [] ;
            // if (artworkSrc) {
            //     artwork = [{ src: artworkSrc, type: "image/png" }];
            // }
            // if ("mediaSession" in navigator) {

            //     navigator.mediaSession.metadata = new MediaMetadata({
            //          album,
            //          artist,
            //          artwork,
            //          title,
            //     });

            // navigator.mediaSession.setActionHandler("play", this.play);
            // navigator.mediaSession.setActionHandler("pause", this.pause);
            // navigator.mediaSession.setActionHandler("seekbackward", function() {});
            // navigator.mediaSession.setActionHandler("seekforward", function() {});
            // navigator.mediaSession.setActionHandler("previoustrack", function() {});
            // navigator.mediaSession.setActionHandler("nexttrack", function() {});
            // navigator.mediaSession.playbackState = "playing";
            // }
        },
        play() {
            this.$refs["insigthPlayer"].play();
            if ("mediaSession" in navigator) {
                navigator.mediaSession.playbackState = "playing";
            }
        },
        pause() {
            this.$refs["insigthPlayer"].pause();
            if ("mediaSession" in navigator) {
                navigator.mediaSession.playbackState = "paused";
            }
        },
        forward() {
            this.$refs["insigthPlayer"].forward();
        },
        rewind() {
            this.$refs["insigthPlayer"].rewind();
        },
        nextTrack() {
            if (this.audioSources.length > (this.selectedAudioSource + 1)) {
                this.setSelectedAudioSource(this.selectedAudioSource + 1);
            }
        },
        previoustrack() {
            if (this.audioSources.length && (0 >= (this.selectedAudioSource - 1))) {
                this.setSelectedAudioSource(this.selectedAudioSource - 1);
            }
        },
        formatSources(themes = []) {
            this.audioSources = [];
            const sources = _cloneDeep(themes);
            sources.map((item) => {
                item.hasAttachments = false;
                item.progress = 0 ;
                item.duration = 0 ;
                item.seek = 0 ;
                if (item.audio_url) {
                    item.audioSrc = [replaceUrlProtocol(item.audio_url)];
                    item.hasAudio = true;
                }
                return item;
            });
            this.audioSources = _cloneDeep(sources.filter(item => item.hasAudio));
        },
        setSelectedAudioSource(index) {
            this.audioSources[this.selectedAudioSource].progress = this.$refs["insigthPlayer"].progress;
            this.currentAudioState.progress = this.audioSources[index].progress;
            // on change always keep playing
            this.currentAudioState.isPlaying = true; //this.isPlaying;

            this.isPlaying = false;
            this.selectedAudioSource = index;
        },
        restoreCurrentAudioState() {
            let progress = 0;
            if (this.currentAudioState.progress >= 2) {
                progress = (this.currentAudioState.progress - 1) / 100;
            }
            this.$refs["insigthPlayer"].setPlayerProgress(progress);
            if (this.currentAudioState.isPlaying) {
                this.play();
            }
            this.currentAudioState.progress = 0;
            this.currentAudioState.isPlaying = false;
        },
        clearContainer() {
            this.rate = "1.0";
            this.isPlaying = false;
            this.audioSources = [];
            this.selectedAudioSource = 0;
            this.currentAudioState = {};
        }
    },
    beforeDestroy() {
        if ("mediaSession" in navigator) {
            navigator.mediaSession.metadata = null;
            navigator.mediaSession.playbackState = "none";
            navigator.mediaSession.setActionHandler("play", function() {});
        }
    }
}
